import { __read, __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { FocusScope } from 'react-aria';
import { IconButton } from '../../../base/iconButton/IconButton.js';
import { ArrowDownIcon } from '../../../icons/ArrowDownIcon.js';
import { ArrowUpIcon } from '../../../icons/ArrowUpIcon.js';
import styles from './TimePicker.module.scss.js';
import { HourPicker } from './hourPicker/HourPicker.js';
import { MinutePicker } from './minutePicker/MinutePicker.js';

// By default show 12:00 AM
var TimePicker = function (_a) {
    var initHour = _a.hour, initMinute = _a.minute, initIsAM = _a.isAM, onPickTime = _a.onPickTime;
    var hour = initHour || 12;
    var minute = initMinute || 0;
    var isAM = !!initIsAM;
    var _b = __read(useState('time'), 2), mode = _b[0], setMode = _b[1];
    var onSetHour = function (hour) {
        onPickTime(hour, minute, isAM);
        setMode('time');
    };
    var onHourUp = function () {
        if (hour + 1 > 12) {
            onPickTime(1, minute, isAM);
        }
        else {
            onPickTime(hour + 1, minute, isAM);
        }
    };
    var onHourDown = function () {
        if (hour - 1 <= 0) {
            onPickTime(12, minute, isAM);
        }
        else {
            onPickTime(hour - 1, minute, isAM);
        }
    };
    var onSetMinute = function (minute) {
        onPickTime(hour, minute, isAM);
        setMode('time');
    };
    var onMinuteUp = function () {
        if (minute + 1 > 59) {
            onPickTime(hour, 0, isAM);
        }
        else {
            onPickTime(hour, minute + 1, isAM);
        }
    };
    var onMinuteDown = function () {
        if (minute - 1 < 0) {
            onPickTime(hour, 59, isAM);
        }
        else {
            onPickTime(hour, minute - 1, isAM);
        }
    };
    var toggleAM = function () {
        onPickTime(hour, minute, !isAM);
    };
    var buttonCommonProps = {
        className: styles.button,
        variant: 'text',
        color: 'dark',
    };
    return (jsxs(Fragment, { children: [jsx(FocusScope, __assign({ restoreFocus: true, autoFocus: true, contain: true }, { children: jsxs("div", __assign({ className: styles.timePanel }, { children: [jsxs("div", { children: [jsx(IconButton, __assign({}, buttonCommonProps, { onClick: onHourUp, "aria-label": "Increase hour" }, { children: jsx(ArrowUpIcon, {}) })), jsx(IconButton, __assign({}, buttonCommonProps, { onClick: function () { return setMode('hour'); }, "aria-label": "Pick hour" }, { children: hour.toString().padStart(2, '0') })), jsx(IconButton, __assign({}, buttonCommonProps, { onClick: onHourDown, "aria-label": "Decrease hour" }, { children: jsx(ArrowDownIcon, { size: "m" }) }))] }), ":", jsxs("div", { children: [jsx(IconButton, __assign({}, buttonCommonProps, { onClick: onMinuteUp, "aria-label": "Increase minute" }, { children: jsx(ArrowUpIcon, {}) })), jsx(IconButton, __assign({}, buttonCommonProps, { onClick: function () { return setMode('minute'); }, "aria-label": "Pick minute" }, { children: minute.toString().padStart(2, '0') })), jsx(IconButton, __assign({}, buttonCommonProps, { onClick: onMinuteDown, "aria-label": "Decrease minute" }, { children: jsx(ArrowDownIcon, { size: "m" }) }))] }), jsxs("div", { children: [jsx(IconButton, __assign({}, buttonCommonProps, { onClick: toggleAM, "aria-label": isAM ? 'Change to PM' : 'Change to AM' }, { children: jsx(ArrowUpIcon, {}) })), jsx(IconButton, __assign({}, buttonCommonProps, { onClick: toggleAM }, { children: isAM ? 'AM' : 'PM' })), jsx(IconButton, __assign({}, buttonCommonProps, { onClick: toggleAM, "aria-label": isAM ? 'Change to PM' : 'Change to AM' }, { children: jsx(ArrowDownIcon, { size: "m" }) }))] })] })) })), mode === 'hour' && (jsx(HourPicker, { className: styles.hourPicker, buttonClassName: styles.button, contentClassName: styles.hourPickerContent, hour: hour, onSetHour: onSetHour })), mode === 'minute' && (jsx(MinutePicker, { className: styles.minutePicker, buttonClassName: styles.button, contentClassName: styles.minutePickerContent, minute: minute, onSetMinute: onSetMinute }))] }));
};

export { TimePicker };
